import { Component, Input, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { SelectBedRoom } from '../../../state/general/app.actions'
import { MatRadioChange } from '@angular/material';
import { PanierService } from '@app/core';
import { ICartItem } from '@app/shared';
import { find } from 'lodash';

@Component({
  selector: 'app-select-bed-room',
  templateUrl: './select-bed-room.component.html',
  styleUrls: ['./select-bed-room.component.scss']
})
export class SelectBedRoomComponent implements OnInit {
  @Input() idRoom: number;
  @Input() keybedSelected: string;
  @Input() bedding: Array<any>;
  @Input() bookingBasic: boolean;
  constructor(private store: Store<any>, private panierService: PanierService) { }

  ngOnInit() {
  }

  changeBadRadio(event: MatRadioChange) {
    let objBed = this.changeBad(event.value);
    this.store.dispatch(new SelectBedRoom({ bedSelected: objBed, idRoom: this.idRoom }));
  }

  private changeBad(keyBed: string) {
    let valBed = this.getValbed(keyBed);
    let itemCart: ICartItem = find(this.panierService.getItems(), { idRoom: this.idRoom });
    if (itemCart) {
      itemCart.keybed = keyBed;
      itemCart.valbed = valBed;
    }
    return { key: keyBed, val: valBed };
  }

  private getValbed(keyBed): Array<any> {
    let valBed = [];
    let bed = this.bedding.find((i) => i.key == keyBed);
    if (bed) {
      valBed = JSON.parse(JSON.stringify(bed.value));
    }
    return valBed;
  }
}
